export default "__VITE_ASSET__77db58fb__"